import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setToken, clearToken } from '@Redux/token/tokenActions';

export const useReduxToken = () => {

    const dispatch = useDispatch();

    const tokenValue = useSelector((state) => state.token.token);
    const userToken = useSelector((state) => Object.keys(tokenValue || {}).length !== 0 ? tokenValue.token : '');

    const setTokenValue = useCallback(
        (tokenData) => dispatch(setToken(tokenData)),
        [dispatch]
    );

    const clearTokenValue = useCallback(
        () => dispatch(clearToken()),
        [dispatch]
    );

    const getTokenValueByKey = (key, defaultValue)=> {
        return !!tokenValue[key] ? tokenValue[key] : defaultValue;
    }

    return {
        tokenValue: tokenValue,
        getTokenValueByKey: getTokenValueByKey,
        token: userToken,
        setToken: setTokenValue,
        clearToken: clearTokenValue
    };
};

